import React from "react";
import "../../../reusableComponents/ErrorModal/ErrorModal.scss";
import errorIcon from "../../../assets/icons/ErronIconsClose.svg";
import CloseBtn from "../../../assets/icons/ClosebuttonModal.svg";
import {useDispatch, useSelector} from "react-redux";
import {clearErrors} from "../../../store/reducers/error";
import {capitalizeFirstLetter} from "../../../utils/helpers/string";

function ErrorModal() {
  const dispatch = useDispatch();
  const [isClosing, setIsClosing] = React.useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      dispatch(clearErrors());
      setIsClosing(false);
    }, 400);
  };

  const {title, msg, status, customBtn} = useSelector((state) => state.error);

  const handleCustomButtonClick = () => {
    if (customBtn === "verification-kyc/*") {
      window.location.href = "/verification-kyc";
    }
    handleClose();
  };

  const displayMessage =
    typeof msg === "string" && msg.trim().length > 0
      ? msg
      : msg?.detail || msg?.message || (status === 500 ? "Internal server error. Please try again later." : "");

  return status ? (
    <div
      className="error_modal_overlay"
      onClick={handleClose}
    >
      <div
        className={`error_modal_container errorPopupContainer ${isClosing ? "closing" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popupIcon">
          <img
            src={errorIcon}
            alt="error"
          />
        </div>

        <div className="titleContent">
          <h1>{title || "Error"}</h1>
          <p>{capitalizeFirstLetter(displayMessage)}</p>
        </div>

        <div className="actionArea">
          {/* <button
            className="error_modal_close_btn"
            onClick={customBtn ? handleCustomButtonClick : handleClose}
          >
            {customBtn ? "Submit KYC" : "Close"}
          </button> */}
          <img
            src={CloseBtn}
            alt="Close"
            onClick={handleClose}
            className="closeBtnSect"
          />
        </div>
      </div>
    </div>
  ) : (
    false
  );
}

export default ErrorModal;
